import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { SingleChoiceQuestion, EssayQuestion, MultipleChoiceQuestion, FillInBlankQuestion, QuestionSummary, QuestionType, SectionSummary, MatchingQuestion } from '../../../core';
export var QUESTION_API = 'QUESTION_API';
export var QuestionApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(QuestionApi, _AxiosApi);

  var _super = _createSuper(QuestionApi);

  function QuestionApi(axiosInstance, mapper) {
    var _this;

    _classCallCheck(this, QuestionApi);

    _this = _super.call(this, 'questions', axiosInstance);
    _this.axiosInstance = axiosInstance;
    _this.mapper = mapper;
    return _this;
  }

  _createClass(QuestionApi, [{
    key: "findGroupedQuestionsBySection",
    value: function () {
      var _findGroupedQuestionsBySection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var formId, jsonResponse, responseOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                formId = query.formId;
                _context.next = 4;
                return this.axios.get(this.url, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  },
                  params: query
                });

              case 4:
                jsonResponse = _context.sent;
                responseOrError = this.mapResponseToFindGroupedQuestionBySectionOutput(formId, jsonResponse.data);
                return _context.abrupt("return", responseOrError);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function findGroupedQuestionsBySection(_x) {
        return _findGroupedQuestionsBySection.apply(this, arguments);
      }

      return findGroupedQuestionsBySection;
    }()
  }, {
    key: "findQuestions",
    value: function () {
      var _findQuestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query) {
        var jsonResponse;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.get(this.url, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  },
                  params: query
                });

              case 3:
                jsonResponse = _context2.sent;

                if (!(query.type === 'summary')) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", this.mapResponseToQuestionSummaries(jsonResponse.data));

              case 6:
                return _context2.abrupt("return", this.mapResponseToQuestions(jsonResponse.data));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function findQuestions(_x2) {
        return _findQuestions.apply(this, arguments);
      }

      return findQuestions;
    }()
  }, {
    key: "mapResponseToFindGroupedQuestionBySectionOutput",
    value: function mapResponseToFindGroupedQuestionBySectionOutput(formId, responseJsonData) {
      var _this2 = this;

      var parsedResponseBody = responseJsonData;

      if (!parsedResponseBody.data) {
        return Result.fail(parsedResponseBody.message);
      }

      var response = parsedResponseBody.data;
      var sectionSummaries = response.map(function (se) {
        return SectionSummary.create({
          id: se.id,
          formId: formId,
          title: se.title,
          description: se.description,
          index: se.index,
          totalScore: se.totalScore,
          totalQuestion: se.totalQuestion,
          previousSectionId: se.previousSectionId
        }).getValue();
      });
      var questions = [];
      response.forEach(function (se) {
        se.questions.forEach(function (question) {
          questions.push(_this2.mapJsonToQuestion(question));
        });
      });
      return Result.ok({
        sectionSummaries: sectionSummaries,
        questions: questions
      });
    }
  }, {
    key: "mapResponseToQuestionSummaries",
    value: function mapResponseToQuestionSummaries(responseJsonData) {
      try {
        var parsedResponseBody = responseJsonData;

        if (!parsedResponseBody.data) {
          return Result.fail(parsedResponseBody.message);
        }

        var questionSummaries = parsedResponseBody.data.map(function (question) {
          return QuestionSummary.create(question).getValue();
        });
        return Result.ok(questionSummaries);
      } catch (error) {
        return ErrorResultHandler(error);
      }
    }
  }, {
    key: "mapJsonToQuestion",
    value: function mapJsonToQuestion(question) {
      switch (question.type) {
        case QuestionType.Essay:
          return EssayQuestion.fromJson(question).getValue();

        case QuestionType.SingleChoice:
          return SingleChoiceQuestion.fromJson(question).getValue();

        case QuestionType.MultipleChoice:
          return MultipleChoiceQuestion.fromJson(question).getValue();

        case QuestionType.FillInBlank:
          return FillInBlankQuestion.fromJson(question).getValue();

        case QuestionType.Matching:
          return MatchingQuestion.fromJson(question).getValue();
      }
    }
  }, {
    key: "mapResponseToQuestions",
    value: function mapResponseToQuestions(responseJsonData) {
      try {
        var parsedResponseBody = responseJsonData;

        if (!parsedResponseBody.data) {
          return Result.fail(parsedResponseBody.message);
        }

        var questions = parsedResponseBody.data.map(function (question) {
          switch (question.type) {
            case QuestionType.Essay:
              return EssayQuestion.fromJson(question);

            case QuestionType.SingleChoice:
              return SingleChoiceQuestion.fromJson(question);

            case QuestionType.MultipleChoice:
              return MultipleChoiceQuestion.fromJson(question);

            case QuestionType.FillInBlank:
              return FillInBlankQuestion.fromJson(question);
          }
        });
        return Result.combineArray(questions);
      } catch (error) {
        return ErrorResultHandler(error);
      }
    }
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var _parsedResponseBody$d, url, jsonResponse, parsedResponseBody;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url, "/").concat(id);
                _context3.next = 4;
                return this.axios["delete"](url);

              case 4:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;
                return _context3.abrupt("return", Result.ok({
                  formVersion: (_parsedResponseBody$d = parsedResponseBody.data) === null || _parsedResponseBody$d === void 0 ? void 0 : _parsedResponseBody$d.formVersion
                }));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function _delete(_x3) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "move",
    value: function () {
      var _move = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, dto) {
        var url, jsonResponse, parsedResponseBody, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                url = "".concat(this.url, "/").concat(id, "/move");
                _context4.next = 4;
                return this.axios.patch(url, dto);

              case 4:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data; // Move returns QuestionResponse which includes formVersion on the question payload.

                data = parsedResponseBody.data;
                return _context4.abrupt("return", Result.ok({
                  formVersion: data === null || data === void 0 ? void 0 : data.formVersion
                }));

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function move(_x4, _x5) {
        return _move.apply(this, arguments);
      }

      return move;
    }()
  }]);

  return QuestionApi;
}(AxiosApi);